import env from "app/utils/env";
import axios from "axios";
import { FETCH_STRESS_DATA } from "app/actionTypes";

export const fetchProductStressMarketingsData = code => {
	// Legacy feature, todo: remove all reference in code
};
